module.exports = __webpack_public_path__ + "img/iPhone7_sml-e955741fd620d0023c490017081a4cf5.png";